// One toast stack per terminal pane, at its top-right (the bottom of a terminal is where a
// program's input and controls are, so toasts stay out of there): links a program asked to
// open, uploads and their notes. (Losing the connection is ConnectionNotice's.) Newest on top, at most three.
// Toasts never take the keyboard from the terminal.

import type { ReactNode } from 'react';
import { useStore } from '../store';
import { useLeaving } from './ds';
import { OpenLinkCard } from './OpenLinks';
import { TransferToast } from './Transfers';

const MAX_VISIBLE = 3;
export function PaneToasts({ sid }: { sid: number }) {
  const allLinks = useStore((s) => s.openLinks);
  const allTransfers = useStore((s) => s.transfers);

  const items: { key: string; at: number; node: ReactNode }[] = [];
  for (const l of allLinks) if (l.session === sid) items.push({ key: `l${l.id}`, at: l.at, node: <OpenLinkCard link={l} /> });
  for (const t of allTransfers) if (t.session === sid) items.push({ key: `t${t.id}`, at: t.at, node: <TransferToast t={t} /> });
  items.sort((a, b) => b.at - a.at);
  // A card that goes (closed, timed out, pushed past three) leaves first (--dur-exit-md).
  const shown = useLeaving(items.slice(0, MAX_VISIBLE), (i) => i.key, 150);
  if (!shown.length) return null;
  return (
    <div
      className="pane-toasts"
      data-testid="toasts"
      // Clicking a toast's buttons must leave the keyboard with the terminal.
      onPointerDown={(e) => {
        if ((e.target as HTMLElement).closest('button')) e.preventDefault();
      }}
    >
      {shown.map(({ item: i, leaving }) => (
        <div className="toast-slot" key={i.key} data-leaving={leaving ? '' : undefined} inert={leaving || undefined}>
          {i.node}
        </div>
      ))}
    </div>
  );
}
